/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductClaimProcessingStatus } from './ProductClaimProcessingStatus';
import {
    ProductClaimProcessingStatusFromJSON,
    ProductClaimProcessingStatusFromJSONTyped,
    ProductClaimProcessingStatusToJSON,
    ProductClaimProcessingStatusToJSONTyped,
} from './ProductClaimProcessingStatus';
import type { HeoTransactionNumber } from './HeoTransactionNumber';
import {
    HeoTransactionNumberFromJSON,
    HeoTransactionNumberFromJSONTyped,
    HeoTransactionNumberToJSON,
    HeoTransactionNumberToJSONTyped,
} from './HeoTransactionNumber';
import type { ProductClaimReason } from './ProductClaimReason';
import {
    ProductClaimReasonFromJSON,
    ProductClaimReasonFromJSONTyped,
    ProductClaimReasonToJSON,
    ProductClaimReasonToJSONTyped,
} from './ProductClaimReason';

/**
 * 
 * @export
 * @interface ProductClaimSummary
 */
export interface ProductClaimSummary {
    /**
     * 
     * @type {string}
     * @memberof ProductClaimSummary
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ProductClaimSummary
     */
    number?: number;
    /**
     * 
     * @type {Date}
     * @memberof ProductClaimSummary
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ProductClaimSummary
     */
    productNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ProductClaimSummary
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof ProductClaimSummary
     */
    productThumbnailUrl: string;
    /**
     * 
     * @type {HeoTransactionNumber}
     * @memberof ProductClaimSummary
     */
    invoiceNumber: HeoTransactionNumber;
    /**
     * 
     * @type {Date}
     * @memberof ProductClaimSummary
     */
    invoiceCreatedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof ProductClaimSummary
     */
    creditNoteNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductClaimSummary
     */
    rmaNumber?: number;
    /**
     * 
     * @type {ProductClaimProcessingStatus}
     * @memberof ProductClaimSummary
     */
    processingStatus: ProductClaimProcessingStatus;
    /**
     * 
     * @type {ProductClaimReason}
     * @memberof ProductClaimSummary
     */
    reason: ProductClaimReason;
}



/**
 * Check if a given object implements the ProductClaimSummary interface.
 */
export function instanceOfProductClaimSummary(value: object): value is ProductClaimSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('productNumber' in value) || value['productNumber'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('productThumbnailUrl' in value) || value['productThumbnailUrl'] === undefined) return false;
    if (!('invoiceNumber' in value) || value['invoiceNumber'] === undefined) return false;
    if (!('invoiceCreatedAt' in value) || value['invoiceCreatedAt'] === undefined) return false;
    if (!('processingStatus' in value) || value['processingStatus'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function ProductClaimSummaryFromJSON(json: any): ProductClaimSummary {
    return ProductClaimSummaryFromJSONTyped(json, false);
}

export function ProductClaimSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductClaimSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'] == null ? undefined : json['number'],
        'createdAt': (new Date(json['createdAt'])),
        'productNumber': json['productNumber'],
        'productName': json['productName'],
        'productThumbnailUrl': json['productThumbnailUrl'],
        'invoiceNumber': HeoTransactionNumberFromJSON(json['invoiceNumber']),
        'invoiceCreatedAt': (new Date(json['invoiceCreatedAt'])),
        'creditNoteNumber': json['creditNoteNumber'] == null ? undefined : json['creditNoteNumber'],
        'rmaNumber': json['rmaNumber'] == null ? undefined : json['rmaNumber'],
        'processingStatus': ProductClaimProcessingStatusFromJSON(json['processingStatus']),
        'reason': ProductClaimReasonFromJSON(json['reason']),
    };
}

export function ProductClaimSummaryToJSON(json: any): ProductClaimSummary {
    return ProductClaimSummaryToJSONTyped(json, false);
}

export function ProductClaimSummaryToJSONTyped(value?: ProductClaimSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'number': value['number'],
        'createdAt': value['createdAt'].toISOString(),
        'productNumber': value['productNumber'],
        'productName': value['productName'],
        'productThumbnailUrl': value['productThumbnailUrl'],
        'invoiceNumber': HeoTransactionNumberToJSON(value['invoiceNumber']),
        'invoiceCreatedAt': value['invoiceCreatedAt'].toISOString(),
        'creditNoteNumber': value['creditNoteNumber'],
        'rmaNumber': value['rmaNumber'],
        'processingStatus': ProductClaimProcessingStatusToJSON(value['processingStatus']),
        'reason': ProductClaimReasonToJSON(value['reason']),
    };
}

